import React from 'react';

import { Props } from './NavigationButton.types';
import { Styled } from './NavigationButton.styles';

import backIcon from 'images/arrow-left.svg';

export const BackButton: React.FC<Props> = (props) => {
  return (
    <Styled.NavigationButton {...props}>
      <img alt="Назад" src={backIcon} />
    </Styled.NavigationButton>
  );
};
